export default "__VITE_ASSET__CiXjdO0V__"